export const PNI_AGENT_MATCH_MESSAGES = {
  Matches: 'Matching PNI agents:',
  NoAgents: 'There are no PNI agents to match tags with',
  NoMatches: 'There are no matching PNI agents for the current tag(s)'
} as const

export const PNI_AGENT_MATCH_ERROR_FALLBACK_MESSAGE =
  'There was an issue getting the list of PNI agent tag matches. Please try again later.'
